export enum DEVICE_CREDENTIALS {
    DEVICE_TYPE = "WEB",
    DEVICE_TOKEN = "WEB"
}